import { TnplShippingPolicy } from "@redotech/redo-tnpl-settings-common/tnpl-settings";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

export const TnplContractTemplateSchema = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
  team: zExt.objectId().meta({ privacy: privacy.nonPii }),
  name: z.string().min(1).meta({ privacy: privacy.nonPii }),
  description: z.string().optional().meta({ privacy: privacy.redact }),
  trialPeriodDays: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  trialPeriodHours: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  trialPeriodMinutes: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  trialEndChargeDelayDays: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  trialEndChargeDelayHours: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  trialEndChargeDelayMinutes: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  merchantProcessingDays: z
    .number()
    .min(0)
    .optional()
    .default(10)
    .meta({ privacy: privacy.nonPii }),
  productIds: z
    .array(z.number().meta({ privacy: privacy.nonPii }))
    .meta({ privacy: privacy.nonPii }),
  sellingPlanId: z.number().nullish().meta({ privacy: privacy.nonPii }),
  sellingPlanGroupId: z.number().nullish().meta({ privacy: privacy.nonPii }),
  emailSubjectLine: z.string().optional().meta({ privacy: privacy.redact }),
  cartValueLimit: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  cartMaxTnplItems: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.nonPii }),
  shippingPolicy: z
    .custom<TnplShippingPolicy>()
    .meta({ annotation: "String", privacy: privacy.null })
    .optional(),
  createdAt: z.date().meta({ privacy: privacy.nonPii }),
  updatedAt: z.date().meta({ privacy: privacy.nonPii }),
});

export type TnplContractTemplate = z.infer<typeof TnplContractTemplateSchema>;
export interface ITnplContractTemplate extends z.ZodType<TnplContractTemplate> {}

export type TnplContractTemplateInAutoCheck = Pick<
  TnplContractTemplate,
  | "trialPeriodDays"
  | "trialPeriodMinutes"
  | "cartValueLimit"
  | "cartMaxTnplItems"
>;
